import { ReactChild, ReactFragment, ReactPortal, ReactElement } from 'react';
import MuiTooltip from '@mui/material/Tooltip';
import styled from 'styled-components/macro';

type TooltipProps = {
    title: boolean | ReactChild | ReactFragment | ReactPortal;
    children: ReactElement;
};

// Custom wrapper with our defaults for MUI tooltip and a custom
// title wrapper.
const Tooltip = ({ title, children }: TooltipProps) => (
    <MuiTooltip
        arrow
        placement="top"
        title={<TooltipContent>{title}</TooltipContent>}
        enterTouchDelay={100}
        enterDelay={100}
    >
        {children}
    </MuiTooltip>
);

const TooltipContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
 `;

export default Tooltip;
